<template>
    <AbaDadosCadastrais
        :idFrom="$route.params.id != undefined ? +$route.params.id : 0"
        :isUpdate="isUpdate"
        :newToEdit="newToEdit"
        :abrev="abrev"
        @voltar="redirectToPage()" 
        @saved="redirectToEdit"
    />
</template>

<script>
import AbaDadosCadastrais from '@/components/vendas/cliente/AbaDadosCadastrais.vue';

export default {
    name: 'AbaDadosCadastraisRoute',
    beforeRouteLeave(to, from, next) {
        if (
            from.name == `${this.abrev}-cliente-dados-cadastrais-new` &&
            to.name == `${this.abrev}-cliente-dados-cadastrais-edit`
        ) {
            this.isUpdate = true;
            this.newToEdit = true;
            setTimeout(() => {
                this.newToEdit = false;
            }, 500);
        }
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    components: {
        AbaDadosCadastrais,
    },
    data() {
        return {
            isUpdate: false,
            newToEdit: false,
            abrev: this.$route.meta.contexto.slice(0,3),
        }
    },
    created() {
        if (this.$route.params.id !== undefined) this.isUpdate = true;

        if (this.$route.meta.contexto == "agro") {
            this.abrev = this.$route.meta.contexto.slice(0,4);
        }
    },
    methods: {
        redirectToPage() {
            if (this.$route.query.tela == 'empresa-cliente'){
                setTimeout(() => {
                    this.$router.push({
                        name: `${this.abrev}-empresa-dados-cadastrais-edit`,
                        params: { id: this.$route.query['id'] },
                        query: { 
                            dadoscadastrais: this.$route.query.dadoscadastrais, 
                            politicacomercial: this.$route.query.politicacomercial,
                        },
                    });
                }, 1000);
            }else {
                setTimeout(() => { this.$router.push({ name: `${this.abrev}-cliente-list`}); }, 1000);
            }
        },
        redirectToEdit(id) {

            let telaModulo = "agro";
            if (this.$route.meta.contexto == "vendas") telaModulo = "ven";

            if (this.$route.query.tela == 'empresa-cliente'){
                setTimeout(() => {
                    this.$router.push({
                        name: `${telaModulo}-empresa-dados-cadastrais-edit`,
                        params: { 
                            id: this.$route.query['id']
                        },
                        query: { 
                            dadoscadastrais: this.$route.query.dadoscadastrais, 
                            politicacomercial: this.$route.query.politicacomercial,
                        },
                    });
                }, 1000);
            }else {
                let tempTela;
                let tempId = id;
                if (this.$route.query.tela == `${telaModulo}-produto-dados-cadastrais-edit` || this.$route.query.tela == `${telaModulo}-produto-dados-cadastrais-new`) {
                    tempTela = this.$route.query.tela;
                    setTimeout(() => {
                        this.$router.push({
                            name: tempTela,
                            params: { 
                                id: tempId
                            },
                            query: {
                                dadoscadastrais: this.$route.query.dadoscadastrais,
                                politicacomercial: this.$route.query.politicacomercial,
                                analisecomercial: this.$route.query.analisecomercial
                            }
                        });
                    }, 1000);
                } else {
                    if(this.$route.query.tela) {
                        tempTela = this.$route.query.tela;
                        tempId = this.$route.query.id;
                    } else {
                        tempTela = `${telaModulo}-cliente-dados-cadastrais-edit`;
                        tempId = id;
                    }
                    setTimeout(() => {
                        this.$router.push({
                            name: tempTela,
                            params: { id: tempId },
                        });
                    }, 1000);
                }
            }
        },
    },
};
</script>
